.urlInputModalContainer {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /* width: 400px; */
  display: flex;
  margin: 10px;
  z-index: 11;
}

.urlInputModal {
  position: relative;
  padding: var(--spacer-1) var(--spacer-2);
  gap: var(--spacer-2);
  align-items: center;

  input {
    flex: 1;
    border: none;
    outline: none;
    box-shadow: none;
    background: none;
    height: 20px;
    width: 290px;

    /* Overrite the padding adding by our general input styles */
    margin-bottom: 0;
  }
}

.separator {
  height: 32px;
  border-left: 1px solid var(--theme-primary-border);
  padding-right: var(--spacer-1);
  margin-left: var(--spacer-1);
}
